@use '@/scss/underscore' as _;

.notice {
  margin: _.unit(4) 0 0;
}
